<template>
     <el-container class="pagination-list">
      <el-main>
        <div class="content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <div class="operation">
                <el-input v-model="conditions.searchString" placeholder="请输入表单名称" @keyup.enter.native="search" clearable/>
                <el-button class="search-button" @click="search">查询</el-button>
              </div>
            </el-form-item>
            <el-form-item class="operation-buttons">
                <el-button @click="addRow" type="primary">新建表单</el-button>
            </el-form-item>
          </el-form >
          <table-list
            ref="tableList"
            :type="'form'"
            :items="items"
            :cols="cols"
            :loading="loading"
            :pagination="pagination"
             @saveAs="saveAs"
             @changePagination="getTableData"
             @editRow="editRow"
             @editOutsideChain="editOutsideChain"
             @delRow="delRow"
             @viewRow="viewRow"></table-list>
        </div>
      </el-main>
      <dialog-form-runtime :formRuntimeDialog="formRuntimeDialog"></dialog-form-runtime>
      <public-design-dialog v-if="designDialog.visiable" :designDialog="designDialog" @closeForm="close"></public-design-dialog>
  </el-container>
</template>

<script>
import TableList from '../../shared/table-list.vue'

import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
import PublicDesignDialog from '@/components/shared/public-design-dialog.vue'
export default {
  name: 'formDesignList',
  components: {
    TableList,
    DialogFormRuntime,
    PublicDesignDialog
  },
  data () {
    return {
      designDialog: {
        visiable: false,
        id: '',
        type: '',
        changePage: true
      },
      conditions: { searchString: '' },
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      cols: [
        {prop: 'name', label: '表单名称'},
        {prop: 'createdBy', label: '创建人'},
        {prop: 'createdDate', label: '创建时间'},
        {prop: 'lastModifiedBy', label: '更新人'},
        {prop: 'lastModifiedDate', label: '更新时间'}
      ],
      filters: {},

      formRuntimeDialog: {
        visible: false,
        id: '',
        width: '',
        dataId: '',
        type: 'form',
        formValidates: [],
        interactions: []
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面关闭弹窗
    this.formRuntimeDialog.visible = false
    next()
  },
  created () {
    this.getTableData()
  },
  methods: {
    addRow () {
      this.designDialog.id = ''
      this.designDialog.type = 'form'
      this.designDialog.visiable = true
      this.designDialog.changePage = true
    },
    editRow (row) {
      this.designDialog.type = 'form'
      this.designDialog.visiable = true
      this.designDialog.id = row.id
      this.designDialog.changePage = false
    },
    viewRow (row) {
      this.formRuntimeDialog.id = row.id
      this.$axios.get('/form-api/defines/' + this.formRuntimeDialog.id)
        .then(res => {
          this.formRuntimeDialog.width = JSON.parse(res.data.form.form.properties).formScreen || 'full'
          this.formRuntimeDialog.visible = true
          this.formRuntimeDialog.title = '新建'
          this.formRuntimeDialog.formValidates = res.data.form.form.formValidates && res.data.form.form.formValidates.filter(n => n.operationType.includes('create') && n.enable)
          this.formRuntimeDialog.interactions = res.data.form.form.interactions ? res.data.form.form.interactions.filter(n => n.type.includes('create')) : []
        })
    },
    delRow (row) {
      let formId = row.id
      this.$confirm('', '你确定要删除吗?', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        customClass: 'deleMessageBox',
        center: true
      })
        .then(() => this.$axios.delete('/form-api/defines/' + formId))
        .then(res => {
          this.getTableData()
        })
    },
    editOutsideChain (row) {
      this.designDialog.type = 'outsideChain'
      this.designDialog.visiable = true
      this.designDialog.id = row.id
      this.designDialog.changePage = false
    },
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'searchString': this.conditions.searchString.trim()
      }
      this.getTableData()
    },
    reset () {
      this.conditions.searchString = ''
      this.pagination.currentPage = 1
      this.filters = {}
      this.getTableData()
    },
    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters

      this.$axios.get('/form-api/defines', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
          this.$nextTick(() => {
            // 翻页的时候让滚动条调整到最上方
            if (this.$refs.tableList && this.$refs.tableList.$refs && this.$refs.tableList.$refs.table) {
              this.$refs.tableList.$refs.table.bodyWrapper.scrollTop = 0
            }
          })
        }).catch(() => {
          this.loading = false
        })
    },
    close () {
      if (this.designDialog.changePage) {
        this.pagination.currentPage = 1
      }
      this.initParams()
    },
    saveAs (row, copyLoading) {
      this.$axios.get(`/form-api/defines/saveAs/${row.id}`)
        .then(() => {
          copyLoading.close()
          this.$message({
            message: '复制成功',
            center: true,
            duration: 1000,
            customClass: 'without-execute-dialog'
          })
          this.search()
        })
        .catch(error => {
          this.$message.error(error.response.data ? error.response.data.message : error.message)
          copyLoading.close()
        })
    }

  }
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
</style>



// WEBPACK FOOTER //
// src/components/form/design/definition-list.vue